import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_TRIPS_REQUEST,
    FETCH_TRIPS_SUCCESS,
    FETCH_TRIPS_FAILURE,
    FETCH_TRIPS_POLICIES_REQUEST,
    FETCH_TRIPS_POLICIES_SUCCESS,
    FETCH_TRIPS_POLICIES_FAILURE,
    FETCH_TRIPS_CLAIMS_REQUEST,
    FETCH_TRIPS_CLAIMS_SUCCESS,
    FETCH_TRIPS_CLAIMS_FAILURE,
    FETCH_TRIPS_CLAIMS_TODAY_REQUEST,
    FETCH_TRIPS_CLAIMS_TODAY_SUCCESS,
    FETCH_TRIPS_CLAIMS_TODAY_FAILURE,
    FETCH_TRIPS_CHECK_CLAIMS_REQUEST,
    FETCH_TRIPS_CHECK_CLAIMS_SUCCESS,
    FETCH_TRIPS_CHECK_CLAIMS_FAILURE,
    FETCH_TRIPS_FORECASTS_REQUEST,
    FETCH_TRIPS_FORECASTS_SUCCESS,
    FETCH_TRIPS_FORECASTS_FAILURE,
    FETCH_TRIPS_SUBCOVERAGES_REQUEST,
    FETCH_TRIPS_SUBCOVERAGES_SUCCESS,
    FETCH_TRIPS_SUBCOVERAGES_FAILURE,
    FETCH_TRIPS_OBSERVATIONS_REQUEST,
    FETCH_TRIPS_OBSERVATIONS_SUCCESS,
    FETCH_TRIPS_OBSERVATIONS_FAILURE,
    FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST,
    FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_SUCCESS,
    FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_FAILURE,
    FETCH_FORECAST_NOT_TRIGGERED_BY_ID_REQUEST,
    FETCH_FORECAST_NOT_TRIGGERED_BY_ID_SUCCESS,
    FETCH_FORECAST_NOT_TRIGGERED_BY_ID_FAILURE,
    FETCH_TRIP_BY_ID_REQUEST,
    FETCH_TRIP_BY_ID_SUCCESS,
    FETCH_TRIP_BY_ID_FAILURE,
    FETCH_TRIP_POLICY_BY_ID_REQUEST,
    FETCH_TRIP_POLICY_BY_ID_SUCCESS,
    FETCH_TRIP_POLICY_BY_ID_FAILURE,
    FETCH_TRIP_SUBCOVERAGE_BY_ID_REQUEST,
    FETCH_TRIP_SUBCOVERAGE_BY_ID_SUCCESS,
    FETCH_TRIP_SUBCOVERAGE_BY_ID_FAILURE,
    FETCH_TRIP_OBSERVATION_REQUEST,
    FETCH_TRIP_OBSERVATION_SUCCESS,
    FETCH_TRIP_OBSERVATION_FAILURE,
    CHANGE_POLICY_STATUS_REQUEST,
    CHANGE_POLICY_STATUS_SUCCESS,
    CHANGE_POLICY_STATUS_FAILURE,
    UPDATE_TRIP_SUBCOVERAGE_REQUEST,
    UPDATE_TRIP_SUBCOVERAGE_SUCCESS,
    UPDATE_TRIP_SUBCOVERAGE_FAILURE,
    CREATE_TRIP_REQUEST,
    CREATE_TRIP_SUCCESS,
    CREATE_TRIP_FAILURE,
    CREATE_SUBCOVERAGES_TRIP_REQUEST,
    CREATE_SUBCOVERAGES_TRIP_SUCCESS,
    CREATE_SUBCOVERAGES_TRIP_FAILURE,
    FETCH_SUBCOVERAGES_BY_PARTNER_REQUEST,
    FETCH_SUBCOVERAGES_BY_PARTNER_SUCCESS,
    FETCH_SUBCOVERAGES_BY_PARTNER_FAILURE,
    UPDATE_TRIP_REQUEST,
    UPDATE_TRIP_SUCCESS,
    UPDATE_TRIP_FAILURE,
    DELETE_TRIP_REQUEST,
    DELETE_TRIP_SUCCESS,
    DELETE_TRIP_FAILURE,
    DELETE_TRIP_FORECAST_NOT_TRIGGERED_REQUEST,
    DELETE_TRIP_FORECAST_NOT_TRIGGERED_SUCCESS,
    DELETE_TRIP_FORECAST_NOT_TRIGGERED_FAILURE,
    DELETE_TRIP_CHECK_CLAIM_REQUEST,
    DELETE_TRIP_CHECK_CLAIM_SUCCESS,
    DELETE_TRIP_CHECK_CLAIM_FAILURE,
} from '../actions/tripsActions';
import { getTrips, getPoliciesTrips, getClaimsTrips, getTripsClaimsToday, getTripsCheckClaims, getForecastTrips, getTripsObservations, getTripObservationById, getForecastsNotTriggeredTrips, getForecastNotTriggeredById, getTripById, getTripPolicyById, changePolicyStatus, createTrip, updateTrip, deleteTrip, createSubcoveragesTrip, getSubcoveragesByPartner, getSubcoveragesTrips, getSubcoverageTripById, updateSubcoverageTrip, deleteTripForecastNotTriggered, deleteTripCheckClaim } from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

function* fetchTripsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getTrips, params);
        yield put({ type: FETCH_TRIPS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des séjours');
        yield put({ type: FETCH_TRIPS_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsPoliciesSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getPoliciesTrips, params);
        yield put({ type: FETCH_TRIPS_POLICIES_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des polices trips');
        yield put({ type: FETCH_TRIPS_POLICIES_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsClaimsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getClaimsTrips, params);
        yield put({ type: FETCH_TRIPS_CLAIMS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des sinistres trips');
        yield put({ type: FETCH_TRIPS_CLAIMS_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsClaimsTodaySaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getTripsClaimsToday, params);
        yield put({ type: FETCH_TRIPS_CLAIMS_TODAY_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des sinistres trips d\'aujourd\'hui');
        yield put({ type: FETCH_TRIPS_CLAIMS_TODAY_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsCheckClaimsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getTripsCheckClaims, params);
        yield put({ type: FETCH_TRIPS_CHECK_CLAIMS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des check claims trips');
        yield put({ type: FETCH_TRIPS_CHECK_CLAIMS_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsForecastsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getForecastTrips, params);
        yield put({ type: FETCH_TRIPS_FORECASTS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des prévisions trips');
        yield put({ type: FETCH_TRIPS_FORECASTS_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsObservationsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getTripsObservations, params);
        yield put({ type: FETCH_TRIPS_OBSERVATIONS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des observations trips');
        yield put({ type: FETCH_TRIPS_OBSERVATIONS_FAILURE, payload: errorMessage });
    }
}

function* fetchTripObservationSaga(action) {
    try {
        const observationId = action.payload;
        const data = yield call(getTripObservationById, observationId);
        yield put({ type: FETCH_TRIP_OBSERVATION_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement du détail observation trip');
        yield put({ type: FETCH_TRIP_OBSERVATION_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsSubcoveragesSaga(action) {
    try {
        const params = action.payload || {};
        console.log('📤 Saga fetchTripsSubcoveragesSaga - params reçus:', params);
        console.log('📤 Saga - action.payload:', action.payload);
        const data = yield call(getSubcoveragesTrips, params);
        console.log('✅ FETCH_TRIPS_SUBCOVERAGES_SUCCESS - Données reçues:', data);
        console.log('✅ Structure des données:', {
            hasSubcoveragesTrip: !!data?.subcoverages_trip,
            hasData: !!data?.data,
            isArray: Array.isArray(data),
            keys: data ? Object.keys(data) : [],
        });
        yield put({ type: FETCH_TRIPS_SUBCOVERAGES_SUCCESS, payload: data });
    } catch (error) {
        console.error('❌ FETCH_TRIPS_SUBCOVERAGES_FAILURE:', error);
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des sous-couvertures trips');
        yield put({ type: FETCH_TRIPS_SUBCOVERAGES_FAILURE, payload: errorMessage });
    }
}

function* fetchTripsForecastsNotTriggeredSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getForecastsNotTriggeredTrips, params);
        yield put({ type: FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des prévisions non déclenchées');
        yield put({ type: FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_FAILURE, payload: errorMessage });
    }
}

function* fetchForecastNotTriggeredByIdSaga(action) {
    try {
        const data = yield call(getForecastNotTriggeredById, action.payload);
        yield put({ type: FETCH_FORECAST_NOT_TRIGGERED_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des détails de la prévision non déclenchée');
        yield put({ type: FETCH_FORECAST_NOT_TRIGGERED_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* fetchTripByIdSaga(action) {
    try {
        const data = yield call(getTripById, action.payload);
        yield put({ type: FETCH_TRIP_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement du séjour');
        yield put({ type: FETCH_TRIP_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* createTripSaga(action) {
    try {
        const { partnerId, tripData } = action.payload;
        const data = yield call(createTrip, partnerId, tripData);
        yield put({ type: CREATE_TRIP_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création du séjour');
        yield put({ type: CREATE_TRIP_FAILURE, payload: errorMessage });
    }
}

function* createSubcoveragesTripSaga(action) {
    try {
        const { partnerId, subcoveragesData } = action.payload;
        const data = yield call(createSubcoveragesTrip, partnerId, subcoveragesData);
        yield put({ type: CREATE_SUBCOVERAGES_TRIP_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création des sous-couvertures');
        yield put({ type: CREATE_SUBCOVERAGES_TRIP_FAILURE, payload: errorMessage });
    }
}

function* fetchSubcoveragesByPartnerSaga(action) {
    try {
        const partnerId = action.payload;
        const data = yield call(getSubcoveragesByPartner, partnerId);
        yield put({ type: FETCH_SUBCOVERAGES_BY_PARTNER_SUCCESS, payload: data });
    } catch (error) {
        let errorMessage = handleApiError(error, 'Erreur lors de la récupération des sous-couvertures');
        // Gestion spécifique pour les erreurs 404 (partenaire non trouvé)
        if (error.response?.status === 404) {
            errorMessage = 'Ce partenaire n\'existe pas ou n\'a pas de sous-couvertures. Veuillez vérifier l\'ID du partenaire.';
        } else if (error.response?.status === 400) {
            errorMessage = error.response?.data?.detail || 'Données invalides pour ce partenaire.';
        }
        yield put({ type: FETCH_SUBCOVERAGES_BY_PARTNER_FAILURE, payload: errorMessage });
    }
}

function* updateTripSaga(action) {
    try {
        const { tripId, tripData } = action.payload;
        const data = yield call(updateTrip, tripId, tripData);
        yield put({ type: UPDATE_TRIP_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la modification du séjour');
        yield put({ type: UPDATE_TRIP_FAILURE, payload: errorMessage });
    }
}

function* deleteTripSaga(action) {
    try {
        const tripId = action.payload;
        yield call(deleteTrip, tripId);
        yield put({ type: DELETE_TRIP_SUCCESS, payload: tripId });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression du séjour');
        yield put({ type: DELETE_TRIP_FAILURE, payload: errorMessage });
    }
}

function* fetchTripPolicyByIdSaga(action) {
    try {
        const policyId = action.payload;
        const data = yield call(getTripPolicyById, policyId);
        yield put({ type: FETCH_TRIP_POLICY_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de la police');
        yield put({ type: FETCH_TRIP_POLICY_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* fetchTripSubcoverageByIdSaga(action) {
    try {
        const data = yield call(getSubcoverageTripById, action.payload);
        yield put({ type: FETCH_TRIP_SUBCOVERAGE_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de la sous-couverture trip');
        yield put({ type: FETCH_TRIP_SUBCOVERAGE_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* updateTripSubcoverageSaga(action) {
    try {
        const { subcoverageTripId, payload } = action.payload;
        const data = yield call(updateSubcoverageTrip, subcoverageTripId, payload);
        yield put({ type: UPDATE_TRIP_SUBCOVERAGE_SUCCESS, payload: data });
        // Rafraîchir la liste des sous-couvertures après mise à jour
        yield put({ type: FETCH_TRIPS_SUBCOVERAGES_REQUEST, payload: {} });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la mise à jour de la sous-couverture trip');
        yield put({ type: UPDATE_TRIP_SUBCOVERAGE_FAILURE, payload: errorMessage });
    }
}

function* changePolicyStatusSaga(action) {
    try {
        const { policyId, status } = action.payload;
        const data = yield call(changePolicyStatus, policyId, status);
        yield put({ type: CHANGE_POLICY_STATUS_SUCCESS, payload: { ...data, status } });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du changement de statut de la police');
        yield put({ type: CHANGE_POLICY_STATUS_FAILURE, payload: errorMessage });
    }
}

export function* watchTripsRequests() {
    yield takeEvery(FETCH_TRIPS_REQUEST, fetchTripsSaga);
    yield takeEvery(FETCH_TRIPS_POLICIES_REQUEST, fetchTripsPoliciesSaga);
    yield takeEvery(FETCH_TRIPS_CLAIMS_REQUEST, fetchTripsClaimsSaga);
    yield takeEvery(FETCH_TRIPS_CLAIMS_TODAY_REQUEST, fetchTripsClaimsTodaySaga);
    yield takeEvery(FETCH_TRIPS_CHECK_CLAIMS_REQUEST, fetchTripsCheckClaimsSaga);
    yield takeEvery(FETCH_TRIPS_FORECASTS_REQUEST, fetchTripsForecastsSaga);
    yield takeEvery(FETCH_TRIPS_OBSERVATIONS_REQUEST, fetchTripsObservationsSaga);
    yield takeEvery(FETCH_TRIP_OBSERVATION_REQUEST, fetchTripObservationSaga);
    yield takeEvery(FETCH_TRIPS_SUBCOVERAGES_REQUEST, fetchTripsSubcoveragesSaga);
    yield takeEvery(FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST, fetchTripsForecastsNotTriggeredSaga);
    yield takeEvery(FETCH_FORECAST_NOT_TRIGGERED_BY_ID_REQUEST, fetchForecastNotTriggeredByIdSaga);
    yield takeEvery(FETCH_TRIP_BY_ID_REQUEST, fetchTripByIdSaga);
    yield takeEvery(FETCH_TRIP_POLICY_BY_ID_REQUEST, fetchTripPolicyByIdSaga);
    yield takeEvery(FETCH_TRIP_SUBCOVERAGE_BY_ID_REQUEST, fetchTripSubcoverageByIdSaga);
    yield takeEvery(CHANGE_POLICY_STATUS_REQUEST, changePolicyStatusSaga);
    yield takeEvery(CREATE_TRIP_REQUEST, createTripSaga);
    yield takeEvery(CREATE_SUBCOVERAGES_TRIP_REQUEST, createSubcoveragesTripSaga);
    yield takeEvery(FETCH_SUBCOVERAGES_BY_PARTNER_REQUEST, fetchSubcoveragesByPartnerSaga);
    yield takeEvery(UPDATE_TRIP_REQUEST, updateTripSaga);
    yield takeEvery(DELETE_TRIP_REQUEST, deleteTripSaga);
    yield takeEvery(UPDATE_TRIP_SUBCOVERAGE_REQUEST, updateTripSubcoverageSaga);
    yield takeEvery(DELETE_TRIP_FORECAST_NOT_TRIGGERED_REQUEST, deleteTripForecastNotTriggeredSaga);
    yield takeEvery(DELETE_TRIP_CHECK_CLAIM_REQUEST, deleteTripCheckClaimSaga);
}

function* deleteTripForecastNotTriggeredSaga(action) {
    try {
        yield call(deleteTripForecastNotTriggered, action.payload);
        yield put({ type: DELETE_TRIP_FORECAST_NOT_TRIGGERED_SUCCESS });
        // Recharger la liste après suppression
        yield put({ type: FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST, payload: {} });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression de la prévision non déclenchée');
        yield put({ type: DELETE_TRIP_FORECAST_NOT_TRIGGERED_FAILURE, payload: errorMessage });
    }
}

function* deleteTripCheckClaimSaga(action) {
    try {
        yield call(deleteTripCheckClaim, action.payload);
        yield put({ type: DELETE_TRIP_CHECK_CLAIM_SUCCESS });
        // Recharger la liste après suppression
        yield put({ type: FETCH_TRIPS_CHECK_CLAIMS_REQUEST, payload: {} });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression du check claim');
        yield put({ type: DELETE_TRIP_CHECK_CLAIM_FAILURE, payload: errorMessage });
    }
}



